.issueSummary {
	margin-left: 5px;
}

.icon {
	width: 16px;
	height: 16px;
	background-size: 16px 16px;
}
